export const VIEW_COUNT_START_TIME = 1600725367000;
